import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const SheerLuxe: Site = {
  id: 'sheerluxe',
  logo: 'svg/sheerluxe.svg',
  favicon: 'svg/sheerluxe-favicon.svg',
  label: 'SheerLuxe',
  analyticsName: 'sheerluxe',
  hostname: 'sheerluxe.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
